<template>
  <div class="course">
    <header style="background-image: url(https://www.ttcdw.cn/p/uc/static/img/header-bg.5ddca66.png);">
      <div>《中华人民共和国爱国主义教育法》解读</div>
    </header>
    <div class="content-wrap">
      <div class="left">
        <div class="title">课程简介</div>
        <div class="content">
          <div>
            <p><span
                style="color: rgb(0, 0, 0); font-size: 18px;">家庭教育是爱国主义教育最前沿阵地，家长是第一责任人。家庭教育对孩子成长至关重要。“学校-家庭-社会”的“通识+个性+导向”立体化爱国主义教育体系中，每个环节都发挥着不可替代的作用。学校负责传授爱国主义的基础知识和培养学生的个性特长，家庭则根据孩子的个性化需求，进行有针对性的补充教育，而社会则通过文化和媒体的力量，为孩子提供正确的价值观导向。家庭中的爱国主义教育可以温暖孩子，成为孩子未来发展的驱动力，同时有利于拓宽孩子的视野，促进他们个性的全面发展，使他们的人格更加健全和成熟。家长们通过言传身教，引领孩子深入了解祖国的历史脉络、现状挑战以及未来发展的宏伟蓝图，从而在孩子心中培育出深厚的民族自豪感和自信心。</span>
            </p>
          </div>
        </div>
        <div class="title">课程安排</div>
        <div class="content">
          <ul class="content-ul">
            <li>
              <div class="info-div">
                <p class="name-p">《中华人民共和国爱国主义教育法》解读</p>
                <p class="value-p">
                  2024-09-27 19:00至
                  2024-09-27 19:40
                </p>
              </div>
              <div class="status-div c-red">
                已结束
              </div>
            </li>
          </ul>
        </div>
        <div class="title">讲师</div>
        <div class="content">
          <div>
            <div class="teacher-item">
              <h3 class="teacher-name">姚荣</h3>
              <div class="teacher-introduce">
                <div class="">华东师范大学教育学部高等教育研究所副教授，硕士研究生导师。获聘华东师范大学教育立法研究基地(教育部政策法规司与华东师范大学共建)副主任、上海市政府立法研究基地研究员。</div>

              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="right">
        <p>
          <el-input v-model="input" placeholder="昵称"></el-input>
        </p>
        <p>
          <el-button type="primary" class="action">进入课堂</el-button>
        </p>
      </div>
    </div>
  </div>
</template>


<script>
import Breadcrumbs from './component/breadcrumb.vue';

export default {
  props: {

  },
  data() {
    return {

    }
  },
  components: {
    Breadcrumbs,

  },
  created() {

  },
  mounted() {
    document.title = '山西省第四届家庭教育指导技能大赛报名'
  },
  computed: {

  },
  methods: {


  },

}
</script>
<style lang="scss" scoped>
.course {
  background-color: #F7F8FA;
  min-height: 100vh;
}

header {
  font-size: 30px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 42px;
  height: 88px;
  display: flex;
  align-items: center;
  padding-left: calc(50% - 600px);
  background-repeat: no-repeat;
  background-size: cover;
}

.content-wrap {
  width: 1200px;
  margin: 0 auto;
  margin-top: 20px;
  display: flex;
}

.left {
  flex: 1;
  background: white;
  padding: 0 22px;

  .title {
    color: #333333;
    font-weight: bold;
    position: relative;
    padding: 12px 8px;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #3b70ff;

    &::before {
      content: "";
      display: block;
      width: 3px;
      border-radius: 5px;
      background: #3b70ff;
      position: absolute;
      left: 0;
      height: 20px;
      top: 15px;
    }
  }

  .content {
    overflow: hidden;
    font-size: 15px;
    padding: 15px 0px;
    font-family: PingFang SC-Medium, PingFang SC;
    min-height: 156px;
    background: #ffffff;
    border-radius: 15px;
    opacity: 1;
    line-height: 20px;
    text-align: justify;
    font-weight: 500;
    color: #666666;

    .content-ul {
      li {
        margin-bottom: 10px;
        height: 90px;
        background: #fafafa;
        display: flex;
        padding: 15px 14px;
        align-items: center;

        .info-div {
          margin: 0 10px;
          flex: 1;

          .c-red {
            color: #f44a6f;
          }

          .status-div {
            font-size: 14px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #666666;
          }

          .name-p {
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            margin-bottom: 8px;
          }

          P {
            margin: 0;
            margin-bottom: 2px;
          }
        }
      }
    }

    .teacher-item {
      padding-bottom: 20px;

      .teacher-name {
        font-size: 16px;
        color: #333333;
        font-weight: 500;
        line-height: 22px;
        margin-bottom: 6px;
      }

      .teacher-introduce {
        font-weight: 400;
        color: #666666;
        font-size: 14px;
        line-height: 24px;
        position: relative;
      }
    }
  }
}

.right {
  background: white;
  width: 306px;
  min-height: 800px;
  background: #ffffff;
  border-radius: 4px;
  margin-left: 20px;
  padding: 24px;

  p {
    margin-bottom: 15px;
    width: 100%;

    ::v-deep .el-input {
      position: relative;
      font-size: 14px;
      display: inline-block;
      width: 100%;
    }

    .action{
      margin: 0 auto;
      width: 100%;
      height: 44px;
      background: #3b70ff;
      border-radius: 6px;
      color: white;
    }
  }
}
</style>
